<template>
  <div class="sf-el picture-choice-input">
    <div class="sf-picture-choice">
      <label class="sf-el__label">
        {{ label }}
        <span v-if="required" class="sf-el__required">*</span>
      </label>
      <p v-if="caption" class="sf-el__caption">{{ caption }}</p>
      <div
        class="sf-picture-choice__grid"
        :class="{ [`sf-picture-choice__grid--display-${display}`]: display }"
      >
        <div
          v-for="(choice, index) in choices"
          :key="index"
          class="choice"
          :class="
            multiple
              ? { 'is-selected': selectedChoices.includes(choice.id) }
              : { 'is-selected': selectedChoice === choice.id }
          "
        >
          <input
            v-if="multiple"
            type="checkbox"
            :name="name"
            :value="choice.id"
            v-model="selectedChoices"
            class="checkbox-button"
            :id="`${choice.id}-choice-${index}`"
          />
          <input
            v-else
            type="radio"
            :name="name"
            :value="choice.id"
            v-model="selectedChoice"
            class="radio-button"
            :id="`${choice.id}-choice-${index}`"
          />
          <label :for="`${choice.id}-choice-${index}`">
            <div
              v-if="choice.image"
              class="choice__img"
              :style="{ height: image_height ? image_height + 'px' : 'auto' }"
            >
              <img :src="choice.image" alt="Choice Image" />
            </div>
            <div class="choice__label">
              <div v-if="multiple" class="choice__checkbox">
                <BaseIcon v-if="selectedChoices.includes(choice.id)" name="check" size="16" />
              </div>
              <div v-else class="choice__radio"></div>
              <div class="choice__label-content">
                <span class="choice__title">
                  {{ choice.content }}
                </span>
                <span class="choice__description" v-if="choice.description">
                  {{ choice.description }}
                </span>
              </div>
            </div>
          </label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import BaseIcon from '../../BaseIcon.vue';
  import { watch, ref } from 'vue';
  export default {
    name: 'PictureChoiceElement',
    components: {
      BaseIcon,
    },
    props: {
      label: String,
      description: String,
      caption: String,
      choices: Array,
      name: String,
      modelValue: [String, Array],
      display: [String, Number],
      required: Boolean,
      image_height: [String, Number],
      default_value: String,
      multiple: {
        type: Boolean,
        default: false,
      },
    },
    emits: ['update:modelValue'],
    setup(props, { emit }) {
      const selectedChoice = ref(props.modelValue);
      const selectedChoices = ref(Array.isArray(props.modelValue) ? props.modelValue : []);
      watch(
        () => props.modelValue,
        (newVal) => {
          if (props.multiple) {
            selectedChoices.value = Array.isArray(newVal) ? newVal : [];
          } else {
            selectedChoice.value = newVal;
          }
        }
      );
      watch(selectedChoice, (newValue) => {
        if (!props.multiple) emit('update:modelValue', newValue);
      });
      watch(selectedChoices, (newValue) => {
        if (props.multiple) emit('update:modelValue', newValue);
      });
      const selectRadio = (index) => {
        selectedChoice.value = props.choices[index].id;
      };
      const selectCheckbox = (index) => {
        const id = props.choices[index].id;
        const idx = selectedChoices.value.indexOf(id);
        if (idx === -1) {
          selectedChoices.value.push(id);
        } else {
          selectedChoices.value.splice(idx, 1);
        }
      };
      return {
        selectedChoice,
        selectedChoices,
        selectRadio,
        selectCheckbox,
        multiple: props.multiple,
      };
    },
  };
</script>

<style scoped lang="scss">
  @import './styles/choices.scss';
</style>
